import { PeergroupFormAppState, PeergroupPopupDetails, RelationId } from 'interfaces/peergroups'
import { MenuNavPageType } from 'interfaces/pages'

export type SidebarPane = 'navigation' | 'groups' | 'form'
export type SidebarPaneState = SidebarPane | null
export type SidebarState = {
  shownPane: SidebarPaneState
  peergroupPopup: PeergroupPopupDetails

  // peer groups
  peergroupForm: PeergroupFormAppState
  selectedRelationId: RelationId | null
  isRandomizing: boolean
  counters: NavigationCounters
}

export type NavigationCounters = {
  actual: Partial<NavigationCountersActual>
  stash: NavigationCountersStash
}

export type NavigationCountersActual = {
  unseen_opportunities: number
  reward_balance: string
  [index: string]: number | string | undefined
}

export type NavigationCountersStash = Partial<Pick<NavigationCountersActual, 'unseen_opportunities'>>

export const NAVIGATION_COUNTERS_MAPPING: Partial<Record<MenuNavPageType, keyof NavigationCountersActual>> = {
  feedposts: 'unseen_feeds',
  opportunities: 'unseen_opportunities',
  rewards: 'reward_balance',
}
